export const DEFAULT = {
  defaultPage: 1,
  defaultSize: 1,
} as const
